import apiClient from './apiClient';

export const fetchIpLocations = async (records, ipField = 'ip_address') => {
  const ips = [...new Set(records.map((record) => record?.[ipField]).filter(Boolean))];
  if (!ips.length) return {};
  const response = await apiClient.post('/ip-locations', { ips });
  return response.data || {};
};

export const mergeIpLocations = (records, locations, ipField = 'ip_address') => (
  records.map((record) => record?.[ipField]
    ? { ...record, location: locations[record[ipField]] ?? record.location ?? null }
    : record)
);
